import { useState, useCallback } from "react";

export const useTeamRecordingPlaybackModal = (appProvider, initiatePlayback) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [selectedPlaybackData, setSelectedPlaybackData] = useState(null);

  const openModal = useCallback((program, { playbackContent, playbackContext }) => {
    setSelectedProgram(program);
    setSelectedPlaybackData({ ...playbackContent, ...playbackContext });
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setSelectedProgram(null);
    setSelectedPlaybackData(null);
  }, []);

  const getPlaybackCallback = useCallback(
    (contentId, externalId, stopDeltaTime) => {
      initiatePlayback({
        contentId,
        externalId,
        stopDeltaTime,
        vodPlaybackType: selectedPlaybackData?.vodPlaybackType,
        contentType: selectedPlaybackData?.contentType,
        playerRoute: selectedPlaybackData?.playerRoute,
        entitlements: selectedPlaybackData?.entitlements,
        channelObj: selectedPlaybackData?.channelObj,
        itemClickAnalyticsCallback: selectedPlaybackData?.itemClickAnalyticsCallback,
        analyticsTitle: selectedPlaybackData?.analyticsTitle,
        unifiedAssetExtendedMetadata: selectedPlaybackData?.unifiedAssetExtendedMetadata,
      });
    },
    [selectedPlaybackData, initiatePlayback]
  );

  return {
    showModal,
    openModal,
    closeModal,
    getPlaybackCallback,
    selectedProgram,
    selectedPlaybackData,
    modalProps: showModal
      ? {
          closeTeamsRecordingInstancesModal: closeModal,
          appProvider,
          recordingResponse: selectedProgram,
          initiatePlayback: getPlaybackCallback,
        }
      : null,
  };
};
